<template>
  <!-- width="600px" 或者  width="60%"   -->
  <el-dialog
    :close-on-click-modal="false"
    title="快速生成计划"
    :show-close="true"
    :visible="true"
    :before-close="handleBeforeClose"
    width="600px"
  >
    <div class="dialog__container quicklyGenerateBox">
      <el-form
        inline
        ref="form"
        class="search-form"
        label-position="right"
        :model="form"
        :rules="rules"
        label-width="70px"
      >
        <el-form-item label="首付金额：" class="mr10" prop="firstAmount">
          <el-input
            size="mini"
            v-number-only
            v-model="form.firstAmount"
            clearable
            ><span slot="suffix">元</span></el-input
          >
        </el-form-item>

        <el-form-item label="计划开始：" class="mb0 mr0" prop="startTime">
          <el-date-picker
            v-model="form.startTime"
            align="right"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="选择日期"
            size="mini"
            prefix-icon=" "
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
        <div class="main">
          <el-form-item label="合同按照：" class="mb0 mr10" prop="period">
            <el-select size="mini" v-model="form.period">
              <el-option :key="1" label="季度支付" :value="3"></el-option>
              <el-option :key="2" label="半年支付" :value="6"></el-option>
              <el-option :key="3" label="年度支付" :value="12"></el-option>
              <el-option :key="4" label="下季度支付" :value="-3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="方式在第："
            class="mb0 mr10 small-item"
            prop="monthNum"
          >
            <el-select size="mini" v-model="form.monthNum">
              <el-option
                :label="item.value"
                :value="item.value"
                v-for="item in monthNumList"
                :key="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="个月的第："
            class="mb0 mr0 small-item"
            prop="dayNum"
          >
            <el-input size="mini" v-number-only v-model="form.dayNum" clearable
              ><span slot="suffix">号</span></el-input
            >
          </el-form-item>

          <span>支付</span>
        </div>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button
        class="plr28"
        size="mini"
        type="info"
        plain
        @click="handleCancel"
        >取消</el-button
      >
      <el-button
        class="plr28"
        type="primary"
        size="mini"
        :loading="loadBtn"
        @click="handleConfirm"
        >确定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { finishContract } from "@/api/ContractManagement";
export default {
  data() {
    return {
      form: {
        endTime: "",
        startTime: "",
        period: "",
        monthNum: "",
        dayNum: ""
      },
      rules: {
        startTime: [
          {
            required: true,
            message: "请选择",
            trigger: "change",
          },
        ],
        firstAmount: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
          },
        ],
        period: [
          {
            required: true,
            message: "请选择",
            trigger: "change",
          },
        ],
        monthNum: [
          {
            required: true,
            message: "请选择",
            trigger: "change",
          },
        ],
        dayNum: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
          },
        ],
      },
      loadBtn: false
    };
  },
  props: {
    endTime: {
      required: true,
    },
    startTime: {
      required: true,
    },
  },
  computed: {
    monthNumList: function() {
      this.form.monthNum = ""
      if (this.form.period) {
        return this.getMonthNumList(Math.abs(this.form.period));
      }
      return [];
    },
  },
  created() {
    this.pickerOptions = {
      disabledDate: (time) => {
        if (this.endTime) {
          const endTime = new Date(this.endTime).getTime();
          return time.getTime() < endTime;
        } else {
          return false;
        }
      },
    };
    this.form.startTime = this.startTime;
  },
  methods: {
    getMonthNumList(ins) {
      let arr = [];
      for (let i = 1; i <= ins; i++) {
        arr.push({
          value: i,
          label: i,
        });
      }
      return arr;
    },
    handleBeforeClose(done) {
      this.$emit("cancel");
      done();
    },
    handleCancel() {
      this.$emit("cancel");
    },
    async handleConfirm() {
      if (this.loadBtn) return;
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.$emit("confirm", this.form);
        }
      });
    },
  },
};
</script>

<style lang="scss">
.quicklyGenerateBox {
  .el-form--inline .el-form-item__content {
    width: 120px;
  }
  .small-item {
    .el-form-item__content {
      width: 90px;
    }
  }
  .el-form--inline .el-form-item.mr10 {
    margin-right: 10px;
  }
  .el-form--inline .el-form-item.mr10 .el-form-item__content {
    margin-right: 0;
  }
  .main {
    display: flex;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ContractManagement/components/QuicklyGenerate.vue